import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useRef, useState } from "react";
import { TiMinus, TiPlus } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { BlogsSlider } from "../../Slider/BlogsSlider";
import { API } from "../../api"; // Adjust the path to your API configuration
import Testimonial from "../../home/Testimonial";
import Offers from "../../products/Offers";
import WhyChose from "../../products/WhyChose";
import "../../products/product.css";

const blogs = [
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "Podcast",
    date: "18, July 2025",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
  {
    type: "News",
    date: "15, June 2021",
    title: "Lorem Ipsum Dolor Sit Amet",
    imageUrl: `${require("../../../Images/tetimonial2.jpg")}`,
    blockUrl: "",
  },
];

const MultiManagerPortfolio = () => {
  const pathRef = useRef(null);
  const heroRef = useRef(null);
  const [steps, setSteps] = useState();
  const [activeIndex, setActiveIndex] = useState(null);
  const [productData, setProductData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Fetch product data from API
  const fetchProductData = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API}/api/product-one-up`, {
        method: "GET",
        headers: {
          Accept: "*/*",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch product data");
      }

      const data = await response.json();

      if (data) {
        setProductData(data);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching product data:", error);
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Helper function to get media URL
  const getMediaUrl = (imageId) => {
    if (!imageId) return "";
    return `${API}/api/media/${imageId}`;
  };

  useEffect(() => {
    fetchProductData();
  }, []);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  useEffect(() => {
    const path = pathRef.current;
    if (!path) return;

    const pathLength = path.getTotalLength();
    path.style.strokeDasharray = pathLength;
    path.style.strokeDashoffset = pathLength;

    const animatePath = () => {
      path.style.transition = "stroke-dashoffset 5s ease-in-out";
      path.style.strokeDashoffset = "0";

      setTimeout(() => {
        path.style.transition = "none";
        path.style.strokeDashoffset = pathLength;

        setTimeout(() => {
          path.style.transition = "stroke-dashoffset 5s ease-in-out";
          path.style.strokeDashoffset = "0";
        }, 100);
      }, 5000);
    };

    const interval = setInterval(animatePath, 7000);
    animatePath();

    return () => clearInterval(interval);
  }, [pathRef.current]);

  useEffect(() => {
    if (loading || !heroRef.current) return;

    const heroBg1up = document.querySelector(".heroBg1up");
    const herotext = document.querySelector(".heroText");

    if (!heroBg1up || !herotext) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          heroBg1up.classList.add("active");
          setTimeout(() => {
            herotext.classList.add("active");
          }, 1000);
        } else {
          herotext.classList.remove("active");
          setTimeout(() => {
            heroBg1up.classList.remove("active");
          }, 500);
        }
      },
      { rootMargin: "0px", threshold: 0.3 }
    );

    observer.observe(heroRef.current);

    return () => {
      observer.disconnect();
    };
  }, [loading]);

  const toggleCollapse = (index) => {
    setActiveIndex(activeIndex == index ? null : index);
  };

  if (loading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "200px" }}
      >
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error && !productData) {
    return (
      <div className="alert alert-warning m-3" role="alert">
        Error loading product data: {error}
      </div>
    );
  }

  const {
    heroSection,
    heroBackgroundSection,
    offersSection,
    projectInfoSection,
    advantage,
    whyChooseSection,
  } = productData;

  return (
    <div>
      <div className="row m-0 p-0 pageBg">
        <div className="col-md-6 d-flex align-items-end justify-content-center">
          <div class="col-11 text-start" data-aos="zoom-in-up">
            <p class="fs-5">{heroSection.title?.title || "Our Products"}</p>
            <p className="fs-1 fw-bold line-height-1 mb-2">
              {heroSection.title?.titleHeading?.text}
              <span className="org">
                {heroSection.title?.titleHeading?.highlight}
              </span>
              {heroSection.title?.heading?.text}
              <span className="org">
                {heroSection.title?.heading?.highlight}
              </span>
              {heroSection.title?.heading?.text2}
            </p>
            <p class="tJustify fw-bold fs-4">{heroSection.question}</p>
            <p class="tJustify fs-5">{heroSection.description}</p>

            <button
              className="buttonEffect mb-2"
              onClick={() => navigate("/about-us")}
            >
              {heroSection.buttonText}
            </button>
          </div>
        </div>
        <div className="col-md-6 d-flex align-items-end justify-content-end">
          <div class="col-md-10 col-12">
            <svg
              id="mySvg"
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="auto"
              viewBox="0 0 869 832"
              fill="none"
              class="mt-4"
            >
              <path
                ref={pathRef}
                id="myPath"
                d="M35.5 832V627.5H232V427H446.5V233H651.5V35H868.5"
                stroke="#F47024"
                strokeWidth="70"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="productHero" ref={heroRef}>
        <div class="heroBg1up"></div>

        <div class="heroText d-flex align-items-center">
          <div class=" col-11">
            <div className="mt-5">
              <h1 className="m-0">
                {heroBackgroundSection.titleHeading.text}{" "}
                <span className="org">
                  {heroBackgroundSection.titleHeading.highlight}
                </span>{" "}
                {heroBackgroundSection.heading.text}
              </h1>
            </div>
            <div className=" d-flex flex-column align-items-center mt-5 gap-5">
              {heroBackgroundSection.cards.map((card, index) => (
                <div key={index} className="border p-5 boredr-color-wrapper">
                  <p class="fs-2 org">{card.highlightedText}</p>
                  <p class="fs-3">{card.description}</p>
                </div>
              ))}
            </div>
            <br />
          </div>
        </div>
      </div>

      <div>
        <div class="col-11 m-auto mt-5">
          <p>{offersSection.title}</p>
          <p class="fs-1">
            {offersSection.subtitle.text}{" "}
            <span class="fw-semibold org">
              {offersSection.subtitle.highlight}
            </span>
          </p>
          <div class="offerMobile">
            <div class="row mt-4 h-100">
              {offersSection.offers.map((offer, index) => (
                <div key={index} class="col-lg-4 col-md-6 mt-4">
                  <div class="col-11 m-auto text-start p-3 investCart">
                    <p class="fs-3 fw-semibold">{offer.title}</p>
                    <div className="my-5">
                      <br />
                    </div>
                    {offer.points &&
                      offer.points.map((point, pointIndex) => (
                        <p key={pointIndex} class="fs-5">
                          {point}
                        </p>
                      ))}

                    {offer.buttonName && (
                      <button
                        className="buttonEffect mt-3"
                        onClick={() => navigate("/about-us")}
                      >
                        {offer.buttonName}
                      </button>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div class="offerPc">
            <Offers offers={offersSection.offers} />
          </div>
        </div>
      </div>
      <div class="mt-3" style={{ background: "#fef8f4" }}>
        <br />
        <div class="col-11 m-auto">
          {projectInfoSection.items.map((el, i) => (
            <div
              key={i}
              class="border-bottom"
              data-bs-toggle="collapse"
              href={`#projectInfo${i}`}
              role="button"
              aria-expanded={activeIndex == i}
              aria-controls={`projectInfo${i}`}
              onClick={() => toggleCollapse(i)}
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="text-start py-2">
                  <p class="fs-2 org">{el.text}</p>
                </div>
                <div>
                  <div
                    style={{
                      width: "30px",
                      height: "30px",
                      borderRadius: "50%",
                      color: "#f47024",
                      border: "2px solid #f47024",
                    }}
                  >
                    {activeIndex == i ? <TiMinus /> : <TiPlus />}
                  </div>
                </div>
              </div>
              {activeIndex == i ? (
                <div>
                  <div class="card card-body border-0">
                    {el.data.map((item, itemIndex) => (
                      <div
                        key={itemIndex}
                        className="bg-whiht mt-4 text-start p-3"
                        style={{ border: "2px solid #f47024" }}
                      >
                        <p className="fs-3">{item.title}</p>
                        {item.imageId && (
                          <img
                            src={getMediaUrl(item.imageId)}
                            style={{ width: "100%" }}
                            alt=""
                            loading="lazy"
                            crossOrigin="anonymous"
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
        <br />
      </div>

      <div class="col-11 m-auto mt-5">
        <p class="fs-1 fw-bold" data-aos="fade-up">
          {advantage.titleLarge.text}
          <span class="org">{advantage.titleLarge.highlight}</span>
          {advantage.subtitle}
        </p>
        <p className="fs-5" data-aos="fade-up">
          {advantage.description}
        </p>
        {advantage.image?.id && (
          <div className="mt-5" data-aos="fade-up">
            <img
              src={getMediaUrl(advantage.image.id)}
              alt=""
              loading="lazy"
              className="largeCapFunds2Image"
              crossOrigin="anonymous"
            />
          </div>
        )}
        <p class="fs-1 mt-5 fw-bold" data-aos="fade-up">
          {advantage?.advantageTitleHeading?.text}
          <span class="org">{advantage?.advantageTitleHeading?.highlight}</span>
          {advantage?.advantageHeading?.text}
        </p>

        <p className="fs-5" data-aos="fade-up">
          {advantage.mainDescription.text}
          <span class="org font-italic">
            {advantage.mainDescription.highlight}
          </span>
          {advantage.lastDescription.text}
        </p>
      </div>

      <WhyChose data={whyChooseSection} />
      <Testimonial />
      <div class="mt-4">
        <div class="col-11 m-auto text-start ">
          <p class="fs-5" data-aos="fade-up">
            Updates
          </p>
          <p class="fs-1 fw-semibold" data-aos="fade-up">
            The latest from{" "}
          </p>
          <p class="fs-1 fw-bold org line-height-1 mb-2" data-aos="fade-up">
            Ladderup
          </p>
          <div className="d-flex gap-3" data-aos="fade-up"></div>
        </div>
        <div data-aos="fade-up">
          <BlogsSlider data={blogs} />
        </div>
      </div>
    </div>
  );
};

export default MultiManagerPortfolio;
